import type { PublicPlatform } from '@/services/platform';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useRouter } from 'vue-router';

export const usePlatformStore = defineStore('platform', () => {
  const router = useRouter();

  const ready = ref(false);
  const platform = ref<PublicPlatform>();

  const update = (updatedPlatform: PublicPlatform | undefined): void => {
    platform.value = updatedPlatform;

    router.isReady().then(() => {
      ready.value = true;
    });
  };

  return {
    ready,
    platform,
    update,
  };
});
